import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';
import type { CommissionGroupDto } from './types';
import { parseCommissionGroupResponse } from './parseCommissionGroupResponse';

export async function getCommissionGroupById(
  divisionId: number,
  groupId: number
): Promise<CommissionGroupDto | null> {
  try {
    const localApi = await getLocalApi();
    const config = apiConfig as Record<string, string>;
    const baseUrl = config.commission_group_get_by_id?.replace('{divisionId}', String(divisionId));
    if (!baseUrl) return null;
    const url = `${baseUrl}?groupId=${encodeURIComponent(String(groupId))}`;
    return await localApi.fetchSingle(
      url,
      (raw: unknown) => {
        const parsed = parseCommissionGroupResponse(raw);
        return parsed.length ? parsed[0] : null;
      },
      'Unable to fetch commission group'
    );
  } catch {
    return null;
  }
}